import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { ordinalOfAnchorStartTag, ordinalOfAnchorEndTag } from './alert-description-helper';

const InventoryThresholdWarningWrapper = ({ content = '' }) => {
  if (!content.length) {
    return null;
  }
  const whereAncorTagBegins = ordinalOfAnchorStartTag(content);
  const whereAnchorTagEnds = ordinalOfAnchorEndTag(content);
  const anchorTag = content.substring(whereAncorTagBegins, whereAnchorTagEnds);
  const anchorTagWithoutHashtag = anchorTag.replace('/#', '');
  const thresholdValue = content.substring(content.indexOf('('), content.indexOf(')') + 1);
  return (
    <React.Fragment>
      <FormattedMessage
        defaultMessage='The product {productDangerousHTML} has reached or gone below the reorder threshold {thresholdValue} established as a warning.'
        description='Inventory threshold alert'
        id='crOsSj'
        values={{
          productDangerousHTML: (
            <span
              /* oxlint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{ __html: anchorTagWithoutHashtag }}
            />
          ),
          thresholdValue,
        }}
      />
    </React.Fragment>
  );
};

InventoryThresholdWarningWrapper.propTypes = {
  content: PropTypes.string.isRequired,
};

export const InventoryThresholdWarning = injectIntl(InventoryThresholdWarningWrapper);
